import React from "react";
import {PersonDocumentType, PersonDocumentTypeRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import {Grid} from "@mui/material";


export const PersonDocumentTypeEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(PersonDocumentTypeRestControllerApiFactory);
    


    const form = useForm({
        fetcher: (id) => ctrl.getPersonDocumentType(id),
        updater: (bean) => ctrl.savePersonDocumentType(bean),
        remover: (id) => ctrl.deleteOrDismissPersonDocumentType(id),
        factory: () => {
            return {} as PersonDocumentType;
        },

    } as UseFormProps<PersonDocumentType>);

    return (
        <>
            <FormContent form={form} title={"Formulario de Tipo de Documento de persona"}>

                <Grid container spacing={3}>
                    <Grid item sm>
                        <FormInput type={"text"} field={"name"} label={"Nombre"}/>
                    </Grid>
                    <Grid item sm={3}>
                        <FormToggle field={"requiredYearMonth"} label={"Require año y mes"}/>
                    </Grid>
                    <Grid item sm={3}>
                        <FormToggle field={"requiredExpiration"} label={"Require fecha expiración"}/>
                    </Grid>
                </Grid>

                <FormInput type={"text"} field={"description"}
                           label={"Descripción visible por el empleado"} rows={10}/>

            </FormContent>
        </>
    );
};